export enum CustomerJoinFailureType {
    UnexpectedState = "UnexpectedState",
    ChatClosed = "ChatClosed",
    CustomerTimedOut = "CustomerTimedOut",
    UnrecoverableFailure = "UnrecoverableFailure",
}
